import React, { useEffect } from 'react';
import { useAuthContext } from 'jsx/auth/AuthProviderV2';
import { useToggle, useRemoveInitApp, useSidebarProducts, useRoleAccess } from 'jsx/hooks';
import { Root, MainContent, Header, Footer, Sidebar } from 'jsx/layout';

import { useTopProducts } from 'hooks';

import Promo from 'pages/Promo';
import PortfolioRoot from 'components/PortfolioRoot';
import MonitorProvider from 'components/MonitorProvider';
import PortfolioProvider from 'components/PortfolioProvider';
import PaymentBehaviorProvider from 'components/PaymentBehaviorProvider';
import { useGoogleAnalytics } from 'jsx/hooks/useGoogleAnalytics';
import { useTranslation } from 'jsx/hooks/useTranslation';
import useProductBreads from 'jsx/hooks/useProductBreadsNoState';
import { LanguageButton } from 'jsx/elements/buttons/LanguageButton';
import MenuButton from 'jsx/layout/MenuButton/MenuButton';
import { UserMenu } from 'jsx/elements/UserMenu/UserMenu';
import PageHeader from 'jsx/layout/PageHeaderV2';

export function App() {
  const [sidebarOpen, toggleSidebar] = useToggle();
  const [userMenuOpen, toggleUserMenu] = useToggle();
  const loaded = useTranslation(2003);
  const { user, isAuthenticated } = useAuthContext();
  const topProducts = useTopProducts();
  const sidebarProducts = useSidebarProducts(291, topProducts);
  useRemoveInitApp(loaded);
  const hasProductAccess = useRoleAccess(291);
  useGoogleAnalytics('UA-56354358-3');

  const breads = useProductBreads(topProducts);
  const subscriberName = isAuthenticated ? user.s_name : '';

  if (!loaded) return null;

  useEffect(() => {
    window.location.href = 'https://fyrirtaeki.creditinfo.is';
  }, []);

  return (
    <Root sidebarOpen={sidebarOpen}>
      <Header
        showMobileNav
        toggleSidebar={toggleSidebar}
        // products={topProducts}
        userMenu={<UserMenu open={userMenuOpen} toggleMenu={toggleUserMenu} />}
      >
        {/* <LanguageButton /> */}
        <MenuButton
          icon="icon-user"
          label={subscriberName}
          onClick={toggleUserMenu}
          open={userMenuOpen}
        />
      </Header>
      {/* <Header
        mainText={user.name}
        subText={user.s_name}
        showMobileNav
        toggleSidebar={toggleSidebar}
        toggleUserMenu={toggleUserMenu}
        products={hasProductAccess ? topProducts : []}
        userMenu={<UserMenu open={userMenuOpen} toggleMenu={toggleUserMenu} />}
      /> */}
      <MainContent>
        {!hasProductAccess ? (
          <Promo />
        ) : (
          <>
            <PageHeader products={topProducts} breadCrumbs={breads}></PageHeader>
            <MonitorProvider>
              <PortfolioProvider>
                <PaymentBehaviorProvider>
                  <PortfolioRoot />
                </PaymentBehaviorProvider>
              </PortfolioProvider>
            </MonitorProvider>
          </>
        )}
      </MainContent>
      {/* <Footer /> */}
      <Sidebar products={sidebarProducts} toggleExpanded={toggleSidebar} isExpanded={sidebarOpen} />
    </Root>
  );
}
